export const de = {
  productsPage: {
    title: "Alle Produkte & Angebote",
    navLabel: "Produkte",
    subtitle: "Alle verfügbaren Hosting-Produkte im Überblick",
    searchPlaceholder: "Produkte oder Anbieter suchen...",
    filterAll: "Alle Kategorien",
    filterAllProviders: "Alle Anbieter",
    noProducts: "Keine Produkte gefunden.",
    free: "Kostenlos",
    viewOffer: "Zum Angebot",
    viewDetail: "Details",
    toProduct: "Zum Produkt",
    toProvider: "Zum Anbieter",
    filterProvider: "Anbieter",
    loadingProducts: "Produkte werden geladen...",
    productsCount: (n) => `${n} Produkt${n !== 1 ? 'e' : ''} gefunden`,
    thProduct: "Produkt",
    thProvider: "Anbieter",
    thPrice: "Preis",
    thCpu: "CPU",
    thRam: "RAM",
    thStorage: "Speicher",
    thBandwidth: "Anbindung",
    thTraffic: "Traffic",
    thDdos: "DDoS-Schutz",
    thActions: "Aktionen",
    rowTooltip: "Angebot ansehen",
    sortTip: "Klick auf Spaltenköpfe zum Sortieren",
    filterLabel: "Kategorie",
    clearFilters: "Filter zurücksetzen",
    showFullContent: "Kompletten Inhalt anzeigen",
    perPage: "pro Seite",
    pageInfo: (from, to, total) => `${from}–${to} von ${total} Produkten`,
    period: { monthly: "/ Monat", yearly: "/ Jahr", "one-time": "einmalig" },
  },
  nav: {
    home: "Startseite",
    compare: "Vergleich",
    submit: "Anbieter einreichen",
    language: "Sprache",
  },
  hero: {
    badge: "Aktuell 2026",
    headline_1: "Finde den perfekten",
    headline_2: "Hosting-Anbieter",
    sub: "Vergleiche die besten deutschen Hosting-Anbieter für Webspace, VServer, Discord Bots, Gameserver und mehr – kostenlos und unabhängig.",
    cta: "Jetzt vergleichen",
    stats: [
      { value: "20+", label: "Anbieter" },
      { value: "100%", label: "Kostenlos" },
      { value: "2026", label: "Aktuell" },
    ],
  },
  table: {
    title: "Hosting-Anbieter im Vergleich",
    count: (n, total) => `${n} von ${total} Anbietern`,
    search: "Suche",
    searchPlaceholder: "Anbieter suchen...",
    sortTip: "Klicke auf Spaltenüberschriften zum Sortieren",
    filterLabel: "Filtern nach:",
    filterAll: "Alle",
    visit: "Besuchen",
    provider: "Anbieter",
    action: "Aktion",
    noResults: "Keine Anbieter gefunden",
    loading: "Laden...",
    details: "Details",
    rowTooltip: "Weitere Infos",
    productRowTooltip: "Produkt ansehen",
  },
  features: {
    webspace: "Webspace",
    domains: "Domains",
    vserver: "VServer",
    dedi: "Dedicated",
    discordbots: "Discord Bots",
    musicbots: "Musicbots",
    licenses: "Lizenzen",
    teamspeak: "TeamSpeak",
    gameserver: "Gameserver",
  },
  detail: {
    title: "Anbieter-Details",
    visit: "Website besuchen",
    close: "Schließen",
    featuresTitle: "Angebotene Dienste",
    available: "Verfügbar",
    unavailable: "Nicht verfügbar",
  },
  provider: {
    backToOverview: "Zurück zur Übersicht",
    since: "Seit",
    services: "Angebotene Dienste",
    productsTitle: "Produkte & Angebote",
    free: "kostenlos",
    visitWebsite: "Website besuchen",
    notFound: "Anbieter nicht gefunden",
    thProduct: "Produkt",
    thCategory: "Kategorie",
    thPrice: "Preis",
    period: { monthly: "/ Monat", yearly: "/ Jahr", "one-time": "einmalig" },
  },
  product: {
    backToProvider: "Zurück zum Anbieter",
    noDescription: "Keine Beschreibung vorhanden.",
    allProducts: "Alle Produkte ansehen",
    visitWebsite: "Website besuchen",
    toProduct: "Zum Produkt",
    sidebarTitle: "Anbieter",
    since: "Seit",
    free: "Kostenlos",
    notFound: "Produkt oder Anbieter nicht gefunden",
    period: { monthly: "pro Monat", yearly: "pro Jahr", "one-time": "einmalig" },
  },
  categories: {
    webspace: "Webspace", vserver: "VServer", dedi: "Dedicated Server",
    gameserver: "Gameserver", teamspeak: "TeamSpeak", discordbots: "Discord Bots",
    musicbots: "Musicbots", domains: "Domains", other: "Sonstiges",
  },
  specs: {
    title: "Technische Spezifikationen",
    cpu_type: "CPU-Typ",
    cpu_cores: "CPU-Kerne",
    ram_type: "RAM-Typ",
    ram_size: "RAM-Größe",
    storage_type: "Speicher-Typ",
    storage_size: "Speicher-Größe",
    bandwidth: "Anbindung",
    ddos_protection: "DDoS-Schutz",
    traffic: "Inkl. Traffic",
    noSpecs: "Keine technischen Daten hinterlegt",
  },
  benefits: {
    title: "Warum unseren Vergleich nutzen?",
    items: [
      {
        title: "Übersichtlich",
        desc: "Alle wichtigen Informationen auf einen Blick. Vergleiche Angebote schnell und einfach.",
      },
      {
        title: "Schnell",
        desc: "Finde in Sekundenschnelle den passenden Anbieter für deine Anforderungen.",
      },
      {
        title: "Kostenlos",
        desc: "Unser Vergleich ist komplett kostenlos und unverbindlich nutzbar.",
      },
      {
        title: "Aktuell",
        desc: "Unsere Datenbank wird regelmäßig aktualisiert, damit du immer die neuesten Anbieter findest.",
      },
    ],
  },
  listing: {
    badge: "Als Anbieter listen",
    title: "Als Anbieter gelistet werden",
    subtitle: "Du betreibst einen Hosting-Dienst und möchtest kostenlos auf Hosting-Community erscheinen? Melde dich einfach – wir prüfen die Aufnahme und klären alles Weitere mit dir.",
    option1_title: "Per E-Mail",
    option1_desc: "Schreib uns eine kurze Mail mit deiner Website und den verfügbaren Diensten.",
    option1_cta: "E-Mail schreiben",
    option1_address: "info@hosting-community.de",
    option2_title: "Per Discord",
    option2_desc: "Tritt unserem Discord-Server bei und erstelle ein Ticket im richtigen Channel – wir antworten zeitnah.",
    option2_cta: "Discord beitreten",
    note: "Die Listung ist kostenlos. Wir behalten uns vor, Anbieter ohne Angabe von Gründen abzulehnen.",
  },
  cookie: {
    text: "Wir verwenden ausschließlich technisch notwendige Cookies, um deine Spracheinstellung zu speichern. Es werden keine Tracking- oder Analyse-Cookies eingesetzt.",
    accept: "Verstanden",
    decline: "Ablehnen",
    privacy: "Datenschutz",
  },
  reviews: {
    title: "Bewertungen",
    avgRating: "Durchschnittsbewertung",
    noReviews: "Noch keine Bewertungen für diesen Anbieter.",
    writeReview: "Bewertung schreiben",
    loginToReview: "Melde dich an, um eine Bewertung zu schreiben.",
    formTitle: "Deine Bewertung",
    titleLabel: "Titel",
    titlePlaceholder: "Kurze Zusammenfassung deiner Erfahrung",
    commentLabel: "Bewertung",
    commentPlaceholder: "Teile deine Erfahrungen mit diesem Anbieter...",
    overallStars: "Gesamtbewertung",
    priceStars: "Preis-Leistung",
    supportStars: "Support",
    speedStars: "Performance",
    submit: "Bewertung einreichen",
    submitting: "Wird eingereicht...",
    successMsg: "Deine Bewertung wurde eingereicht und erscheint nach Admin-Freigabe.",
    pendingBadge: "Ausstehend",
    approvedBadge: "Genehmigt",
    rejectedBadge: "Abgelehnt",
    providerReply: "Antwort vom Anbieter",
    replyLabel: "Antwort schreiben",
    replyPlaceholder: "Deine Antwort auf diese Bewertung...",
    saveReply: "Antwort speichern",
    alreadyReviewed: "Du hast diesen Anbieter bereits bewertet.",
    basedOn: (n) => `${n} Bewertung${n !== 1 ? 'en' : ''}`,
    loginCta: "Jetzt anmelden",
    registerCta: "Konto erstellen",
    orCreate: "oder",
  },
  user: {
    loginTitle: "Willkommen zurück",
    registerTitle: "Konto erstellen",
    accountTitle: "Mein Konto",
    myReviews: "Meine Bewertungen",
    email: "E-Mail",
    password: "Passwort",
    displayName: "Anzeigename",
    displayNamePlaceholder: "Wie soll dein Name angezeigt werden?",
    loginBtn: "Anmelden",
    registerBtn: "Registrieren",
    loggingIn: "Anmelden...",
    registering: "Konto erstellen...",
    logoutBtn: "Abmelden",
    navLogin: "Anmelden",
    navAccount: "Mein Konto",
    noAccount: "Noch kein Konto?",
    otherPortals: "Bist du Admin oder Anbieter?",
    adminPortal: "Admin-Bereich",
    providerPortal: "Anbieter-Portal",
    hasAccount: "Bereits ein Konto?",
    noReviews: "Du hast noch keine Bewertungen geschrieben.",
    pendingNote: "Ausstehende Bewertungen erscheinen nach Admin-Freigabe.",
    reviewFor: "Bewertung für",
    viewProvider: "Anbieter ansehen",
  },
  footer: {
    tagline: "Der unabhängige Hosting-Vergleich für die deutschsprachige Community.",
    links: "Links",
    listProvider: "Als Anbieter listen",
    contact: "Kontakt",
    imprint: "Impressum",
    privacy: "Datenschutz",
    copyright: "© 2026 Hosting-Community. Alle Rechte vorbehalten.",
  },
};
